/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBatteryHalf: {
  name: 'battery-half';
  data: string;
} = {
  name: 'battery-half',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4Zm0 2h13v8H4V8Zm19 2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4ZM6 9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm4 1a1 1 0 0 0-2 0v4a1 1 0 1 0 2 0v-4Z" fill="currentColor"/></svg>`,
};
